import { 
    View,
} from 'ckeditor5'

/**
 * The youtube video preview View class.
 *
 * See {@link module:youtube/ui/previewView~PreviewView}.
 *
 * @extends module:ui/view~View
 */
export default class PreviewView extends View {
    constructor( locale, videoDetails, saveButtonView ) {
        super( locale );

        /**
         * Spread form values into individual variables
         */
        const { videoId, startTime, endTime } = videoDetails;

        /**
		 * A dynamic collection view that allows updating to show video preview or error messages.
		 *
		 * @member {module:ui/viewcollection~ViewCollection}
		 */
        const videoView = this.createCollection();
        
        /** 
         * If videoId isn't 11 characters long then display relevant error message
         */
        if ( !!videoId ) {
            
            if ( videoId.length !== 11) {
                videoView.add(this._createErrorMessage("Invalid video URL"))
            } else {
                const _url = `https://www.youtube.com/embed/${videoId}?rel=0&start=${startTime}&end=${endTime}`
                videoView.add(this._createVideoView(_url))
                saveButtonView.isEnabled = true;
            }
        } else {
            videoView.add(this._createErrorMessage("Please provide a video URL to see a preview."))
        }

        this.setTemplate( {
            tag: 'div',
            children: videoView
        } )
    } 

    /**
	 * Creates a media iframe view.
	 *
	 * @private
	 * @param {String} url The media's URL.
	 * @returns {module:ui/view~View} Iframe media view instance.
	 */
    _createVideoView(url) {
        const videoView = new View( this.locale );

        videoView.setTemplate({
            tag: "iframe",
            attributes: {
                src: `${url}`,
                style: {
                    width: "100%",
                    height: "100%",
                    aspectRatio: "16 / 9",
                },
                frameborder: "0",
                allow: "autoplay; encrypted-media",
                allowfullscreen: "",
            }
        })

        return videoView;
    }

    /**
	 * Creates an error text View.
	 *
	 * @private
	 * @param {String} message The error message to display.
	 * @returns {module:ui/view~View} Error text view instance.
	 */
    _createErrorMessage(message) {
        const errorView = new View( this.locale );

        errorView.setTemplate({
            tag: 'p',
            attributes: {
                style: {
                    color: "red"
                }
            },
            children: [
                message
            ]
        })

        return errorView;
    }
}